import type { Item, Value } from './types';

export const getKey = (item: Item) => {
  if (typeof item === 'string') {
    return item.toString();
  }
  if (typeof item === 'object' && item !== null && 'value' in item) {
    return item.value!.toString();
  }
  return '';
};

export const getValue = (item: Item): Value => {
  if (typeof item === 'string') {
    return item as Value;
  }
  if (typeof item === 'object' && item !== null && 'value' in item) {
    return item.value as Value;
  }
  return null as Value;
};

export const getLabel = (item: Item): string => {
  if (typeof item === 'string') {
    return item;
  }
  if (typeof item === 'object' && item !== null && 'label' in item) {
    return item.label || '';
  }
  return '';
};
